import { Decoration } from "@uiw/react-codemirror";
import { getImageSize } from "@/04-features/edit-image";
import { isSelectionInside } from "../../util/isSelectionInside";
import { MarkdownImageWidget } from "./MarkdownImageWidget";
const unwrapImageText = (text) => {
    return text.replace(/\\([\\\]])/g, "$1");
};
export const getImageDecorations = (view, node) => {
    var _a, _b, _c;
    if (node.name !== "Image") {
        return { decorations: [] };
    }
    const imageSize = getImageSize(view.state, node.to);
    const decorationTo = (_a = imageSize === null || imageSize === void 0 ? void 0 : imageSize.to) !== null && _a !== void 0 ? _a : node.to;
    if (isSelectionInside(view, { from: node.from, to: decorationTo })) {
        return { decorations: [] };
    }
    const urlNode = node.node.getChild("URL");
    if (!urlNode)
        return { decorations: [] };
    const source = view.state.doc.sliceString(urlNode.from, urlNode.to);
    const imageSource = view.state.doc.sliceString(node.from, node.to);
    const altEnd = imageSource.indexOf("](");
    const alt = altEnd >= 0
        ? unwrapImageText(imageSource.slice(2, altEnd))
        : "image";
    const titleNode = node.node.getChild("LinkTitle");
    const titleSource = titleNode
        ? view.state.doc.sliceString(titleNode.from, titleNode.to)
        : null;
    const title = (_b = titleSource === null || titleSource === void 0 ? void 0 : titleSource.slice(1, -1)) !== null && _b !== void 0 ? _b : null;
    const decoration = Decoration.replace({
        widget: new MarkdownImageWidget({
            source,
            alt,
            title,
            width: (_c = imageSize === null || imageSize === void 0 ? void 0 : imageSize.width) !== null && _c !== void 0 ? _c : null,
            imageFrom: node.from,
            imageTo: node.to,
            decorationTo
        })
    });
    return {
        decorations: [decoration.range(node.from, decorationTo)],
        skipChildren: true
    };
};
